<img [src]="logoSource" [attr.width]="width" />
